/* Mirrox performance helpers: prioritize the first visible product image and prefetch likely next pages. */
(function () {
  'use strict';
  var saveData = navigator.connection && navigator.connection.saveData;
  var slowConnection = navigator.connection && /(^|-)2g$/.test(navigator.connection.effectiveType || '');
  function prioritizeFirstProductImage() {
    var images = document.querySelectorAll('#MainContent .t4s-product img.t4s-product-main-img');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var rect = img.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight * 1.25 && rect.bottom > 0) {
        img.setAttribute('fetchpriority', 'high');
        img.setAttribute('loading', 'eager');
        break;
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prioritizeFirstProductImage, { once: true });
  } else {
    prioritizeFirstProductImage();
  }
  if (saveData || slowConnection || !('createElement' in document)) return;
  var prefetched = Object.create(null);
  function eligible(anchor) {
    if (!anchor || anchor.nodeType !== 1 || !anchor.href || anchor.target || anchor.hasAttribute('download')) return false;
    if (anchor.closest('[data-action-atc], [data-action-quickshop], [data-action-quickview], form, .t4s-cart')) return false;
    var url;
    try { url = new URL(anchor.href, location.href); } catch (e) { return false; }
    if (url.origin !== location.origin || url.pathname === location.pathname || url.pathname.indexOf('/checkout') === 0 || url.pathname.indexOf('/cart') === 0 || url.pathname.indexOf('/account') === 0) return false;
    if (url.hash && url.pathname === location.pathname) return false;
    return anchor.matches('a[data-pr-href], .t4s-site-nav a[href], a[data-load-more], .t4s-menu a[href]');
  }
  function prefetch(anchor) {
    if (!eligible(anchor)) return;
    var url = new URL(anchor.href, location.href);
    var key = url.pathname + url.search;
    if (prefetched[key]) return;
    prefetched[key] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url.href;
    document.head.appendChild(link);
  }
  document.addEventListener('pointerover', function (event) {
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (anchor) prefetch(anchor);
  }, { passive: true });
})();
